import React from 'react';
import { MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon, VideoIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
import { contact } from '../data/contact';
const channels = [{
  folio: 'C-01',
  icon: MessageCircleIcon,
  label: 'WhatsApp',
  value: contact.whatsapp,
  href: contact.whatsappHref,
  external: true
}, {
  folio: 'C-02',
  icon: PhoneIcon,
  label: 'Llamada',
  value: contact.phone,
  href: contact.phoneHref,
  external: false
}, {
  folio: 'C-03',
  icon: MailIcon,
  label: 'Correo',
  value: contact.email,
  href: contact.emailHref,
  external: false
}, {
  folio: 'C-04',
  icon: MapPinIcon,
  label: 'Dirección',
  value: contact.address,
  href: contact.addressHref,
  external: true
}, {
  folio: 'C-05',
  icon: VideoIcon,
  label: 'Videollamada',
  value: 'Agenda tu consulta en vivo',
  href: contact.videoCallHref,
  external: true
}];
export function Contact() {
  return <section id="contacto" aria-labelledby="contacto-title" className="relative bg-ink py-20 sm:py-28" data-id="element-3" data-mp="3ouxmj2jh1zng">
      <TornEdge colorClassName="bg-ink" data-id="element-4" data-mp="3b2rgwady3b29" />
      <div className="relative mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-5" data-mp="3f4uscz0m6fnj">
        <Reveal data-id="element-6" data-mp="3f2ruxtx4tk8s">
          <SectionHeading id="contacto-title" folio="Sección VII · Canales de contacto" title="Contacto" data-id="element-7" data-mp="3153a2m32ed3q" />
        </Reveal>

        <ul className="mt-14 grid gap-4 sm:grid-cols-2" data-id="element-8" data-mp="365hkgas51z4x">
          {channels.map(({
          folio,
          icon: Icon,
          label,
          value,
          href,
          external
        }, index) => <Reveal as="li" key={label} delay={index * 0.07} className="sm:last:col-span-2" data-id="element-9" data-mp="2w58lwqaoc1md" data-mpi={index}>
                <a href={href} className="group relative flex h-full items-start gap-5 border border-gold/35 bg-plum-deep/60 p-6 transition-colors hover:border-gold hover:bg-plum-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-gold sm:p-7" {...external ? {
            target: '_blank',
            rel: 'noreferrer'
          } : {}} data-id="element-10" data-mp="uedm7ndcjiad">
                  <span className="absolute right-4 top-3 font-folio text-[0.58rem] uppercase tracking-[0.2em] text-gold/70" data-id="element-11" data-mp="1pbsxegsp7gpu">
                    {folio}
                  </span>
                  <span className="mt-1 flex h-11 w-11 shrink-0 items-center justify-center border border-emerald-soft/50 bg-emerald/25" data-id="element-12" data-mp="2m465oxeh4fmb">
                    <Icon className="h-4 w-4 text-emerald-soft" aria-hidden="true" data-id="element-13" data-mp="2d989nhg14mqr" />
                  </span>
                  <span className="min-w-0" data-id="element-14" data-mp="35q2jt5ddqve1">
                    <span className="block font-folio text-[0.62rem] uppercase tracking-[0.24em] text-gold" data-id="element-15" data-mp="35r45e3s0v0a0">
                      {label}
                    </span>
                    <span className="mt-2 block break-words font-display text-lg font-normal tracking-[0.04em] text-paper" data-id="element-16" data-mp="38aqtr1egkefp">
                      {value}
                    </span>
                  </span>
                </a>
              </Reveal>)}
        </ul>
      </div>
    </section>;
}